export const EDRO_DASHBOARD_ROUTE_NAMES = ["edro-forced-spirometry"];
